export default {
  routes: [
    // {
    //   path: "/",
    //   name: "Login",
    //   meta: {
    //     auth: true,
    //   },
    //   component: () => import("@/view/LoginPage"),
    // },
    //首页
    // {
    //   path: "/home",
    //   name: "Home",
    //   component: () => import("@/view/Home"),
    // },
    //创建会话页
    // {
    //   path: "/create/conversation",
    //   name: "CreateConversation",
    //   component: () => import("@/view/CreateConversation"),
    // },
    //会话页
    {
      path: "/conversation/:botCode/:uuid?",
      name: "ChatView",
      component: () => import("@/view/ChatView"),
    },
    //企业介绍
    {
      path: "/fairInfo/:botCode",
      name: "FairInfo",
      component: () => import("@/view/FairInfo"),
    },
    {
      path: "*",
      name: "Pricing",
      component: () => import("@/view/Pricing"),
    },
    //     {
    //   path: "/",
    //   name: "CreateConversation",
    //   component: () => import("@/view/CreateConversation"),
    // },
    // 登录页
    // {
    //   path: "*",
    //   name: "Login",
    //   meta: {
    //     auth: true,
    //   },
    //   component: () => import("@/view/LoginPage"),
    // },
  ],
  mode: "history",
  // mode: "hash",
};
